import { inject } from "@angular/core";
import {ActivatedRouteSnapshot, type CanActivateFn, type RouterStateSnapshot} from "@angular/router";
import {AuthService} from "../auth/auth.service";

export const telemetryGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {

  const auth = inject(AuthService);
  auth.telemetryData = <any>route.queryParams;

  return true;
}
